import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialogContent,
  FDPaper,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ModalActions } from 'Views/Page/Content/Modal/Layouts/MemberActionItem/Layout/ModalActions';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <>
      <FDDialogContent>
        {resource.attr('description') ? (
          <>
            <MetaControlField attr={'name'} />
            <FDPaper appearance="flat" color="subtle" padding={2}>
              <MetaControlField attr={'description'} />
            </FDPaper>
          </>
        ) : (
          <FDPaper appearance="flat" color="subtle" padding={2}>
            <MetaControlField attr={'name'} />
          </FDPaper>
        )}
      </FDDialogContent>
      <ModalActions />
    </>
  );
};

export default Layout;
